/**
 * BrandLogo — the DraftEdge wordmark IMAGE (the same boxed DRAFT|EDGE mark
 * draftedge.com uses). Replaces the old text wordmark everywhere a header
 * shows the brand, so all properties match.
 *
 * The asset is bundled by Vite (imported, not an absolute URL) so it works
 * in dev, under the /app base in production, and inside the Capacitor
 * mobile WebView.
 */
import logoUrl from '@/assets/logo.png';

export function BrandLogo({ className = 'h-6' }: { className?: string }) {
  return (
    <img
      src={logoUrl}
      alt="DraftEdge"
      className={`w-auto ${className}`}
      draggable={false}
    />
  );
}
